var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form",
        {
          staticClass: "fields",
          attrs: { autocomplete: "off" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "field" },
            [
              _c(
                "label",
                { attrs: { for: "password-input" } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t(_vm.langRoot + ".passwordInputLabel")) +
                      "\n                "
                  ),
                  _c("i8-icon", {
                    staticClass: "password-tips-icon",
                    attrs: { icon: "circle-help" },
                    on: { click: _vm.togglePasswordTipsModal }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "focus",
                    rawName: "v-focus",
                    value: _vm.defaultFocus,
                    expression: "defaultFocus"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password.value,
                    expression: "password.value"
                  }
                ],
                staticClass: "input short",
                class: { error: _vm.showPasswordFeedback },
                attrs: {
                  id: "password-input",
                  type: "password",
                  "data-ci": "new-password-input",
                  "aria-required": "true",
                  "aria-invalid": !_vm.isPasswordStrong,
                  "aria-describedby":
                    _vm.password.requirements.show && !_vm.showPasswordFeedback
                      ? "pwdRequirements"
                      : "pwdFeedback",
                  autocomplete: "off"
                },
                domProps: { value: _vm.password.value },
                on: {
                  focus: function($event) {
                    _vm.password.requirements.show = true
                  },
                  keyup: _vm.emitPassword,
                  blur: function($event) {
                    _vm.password.isDirty =
                      true && _vm.$trackEvent(_vm.pageTag, "password_entered")
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.password, "value", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.password.requirements.show
                ? _c("page-notification", {
                    staticClass: "form-helper",
                    attrs: {
                      id: "pwdRequirements",
                      messages: _vm.$t(_vm.langRoot + ".passwordRules.rule"),
                      name: _vm.$t(_vm.langRoot + ".passwordRules.title"),
                      type: "blank"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPasswordFeedback
                ? _c(
                    "div",
                    {
                      staticClass: "form-feedback",
                      attrs: { id: "pwdFeedback", role: "alert" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "page-notification__icon" },
                        [
                          _c("i8-icon", {
                            attrs: { size: "small", icon: "circle-error-solid" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.passwordInadequate))])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: _vm.langRoot + ".confirmPasswordInputLabel",
                  expression: "`${langRoot}.confirmPasswordInputLabel`"
                }
              ],
              attrs: { for: "password-confirmation-input" }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.confirmation.value,
                  expression: "confirmation.value"
                }
              ],
              staticClass: "input short",
              class: { error: _vm.showConfirmationFeedback },
              attrs: {
                id: "password-confirmation-input",
                type: "password",
                autocomplete: "off",
                "aria-required": "true",
                "aria-invalid": !_vm.isPasswordConfirmed,
                "aria-describedby": "confirmationFeedback",
                "data-ci": "confirmation-password-input"
              },
              domProps: { value: _vm.confirmation.value },
              on: {
                focus: function($event) {
                  _vm.password.requirements.show = true
                },
                keyup: _vm.emitPassword,
                blur: function($event) {
                  _vm.confirmation.isDirty =
                    true &&
                    _vm.$trackEvent(
                      _vm.pageTag,
                      "password_confirmation_entered"
                    )
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.confirmation, "value", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.showConfirmationFeedback
              ? _c(
                  "div",
                  {
                    staticClass: "form-feedback",
                    attrs: { id: "confirmationFeedback", role: "alert" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "page-notification__icon" },
                      [
                        _c("i8-icon", {
                          attrs: { size: "small", icon: "circle-error-solid" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.passwordsNotMatch))])
                  ]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showPasswordTips
        ? _c(
            "i8-modal",
            {
              attrs: {
                "is-open": _vm.showPasswordTips,
                title: _vm.$t(_vm.langRoot + ".securityAdvice.title")
              }
            },
            [
              _c("template", { slot: "i8-modal-body" }, [
                _c(
                  "div",
                  { staticClass: "password-tips copy" },
                  [
                    _vm._l(
                      _vm.$t(_vm.langRoot + ".securityAdvice.content"),
                      function(item, index) {
                        return [
                          item.title
                            ? _c("strong", { key: "title-" + index }, [
                                _vm._v(_vm._s(item.title))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.text
                            ? _c("p", { key: "title-" + index }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(item.text) +
                                    "\n                    "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.textList
                            ? [
                                _c(
                                  "ul",
                                  { key: "text-list-" + index },
                                  _vm._l(item.textList, function(textListItem) {
                                    return _c(
                                      "li",
                                      {
                                        key:
                                          "text-list-item-" +
                                          index +
                                          "-" +
                                          textListItem
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(textListItem) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            : _vm._e()
                        ]
                      }
                    )
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("template", { slot: "i8-modal-footer" }, [
                _c("div", { staticClass: "level is-block" }, [
                  _c("div", { staticClass: "level-right is-pulled-right" }, [
                    _c("button", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: _vm.langRoot + ".securityAdvice.returnBtn",
                          expression: "`${langRoot}.securityAdvice.returnBtn`"
                        }
                      ],
                      staticClass: "btn primary",
                      on: { click: _vm.togglePasswordTipsModal }
                    })
                  ])
                ])
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fe05b0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fe05b0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/NewPassword.vue
// module id = gIB6
// module chunks = 1